import { render, staticRenderFns } from "./statWrapper.vue?vue&type=template&id=b9195ebe&"
import script from "./statWrapper.vue?vue&type=script&lang=js&"
export * from "./statWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports